import "features/bulletins/assets/styles/BulletinTeaser.scss";
import Labels from "components/ui/Labels/Labels";
import Button from "components/ui/Button/Button";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import ButtonLike from "features/likes/components/ButtonLike/ButtonLike";
import ParticipationStatusBar from "components/ui/ParticipationStatusBar/ParticipationStatusBar";

function MonthlyHighlightCurrent({ data }) {
  const history = useHistory();
  const [ likeCount, setLikeCount ] = useState(0);

  return (
    <div className={ `teaser teaser-highlight teaser-highlight-large` }>
      <div className={ 'teaser__inner' }>

        <div className={ `teaser-highlight__content-wrapper ${ data.field_bulletin_image ? `teaser-highlight__content-wrapper--image` : `teaser-highlight__content-wrapper--no-image` }` }>
          {
            data.field_bulletin_image_large &&
            <div className={ 'teaser__image teaser-highlight-large__image' }>
              <ResponsiveImage value={ data.field_bulletin_image_large }/>
            </div>
          }

          <div className={ `teaser__content teaser-highlight-large__content` }>
            <div className={ 'teaser__actions' }>
              <Labels items={ [ data.month ] }/>

              <ButtonLike
                entityId={ parseInt(data.nid) }
                entityType={ `bulletin` }
                onReceivedCount={ (count) => setLikeCount(count) }
              />
            </div>

            <div className={ 'teaser__title' }>
              <h3 className={ 'pointer' } onClick={ () => history.push(data.url) }>{ data.title }</h3>
            </div>

            <div className={ 'teaser__intro' }>
              { data.field_description }
            </div>

            <div className={ 'teaser__buttons' }>
              <Button onClick={ () => history.push(data.url) } variant={ 'secondary' } className={ 'button--small' }>
                Doe ook mee
              </Button>
            </div>

            <ParticipationStatusBar
              likeCount={ likeCount }
              commentCount={ Number(data.comment_count) }
              variant={ `teaser` }
            />
          </div>
        </div>
      </div>
      <span className={ 'link-overlay' } onClick={ () => history.push(data.url) }></span>
    </div>
  );
}

export default MonthlyHighlightCurrent;
